import { render } from "./Pagination.vue?vue&type=template&id=2d1cc628"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d1cc628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d1cc628', __exports__)) {
    api.reload('2d1cc628', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=2d1cc628", () => {
    api.rerender('2d1cc628', render)
  })

}


export default __exports__